import * as React from 'react'

import src from '../assets/images/PM_logotyp-do-skoly-horizontalni_RGB_pink.png'

export const logo = <img className="logo" src={src} alt="Pešky do školy" />
